import {
  Component,
  OnInit
} from '@angular/core';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { NotificationService } from 'src/app/Service/notification.service';
import { DashBoardService } from 'src/app/User/Pages/dash-board/dash-board.service';
@Component({
    selector: 'app-vaultauthentication',
    templateUrl: './weather-popup.component.html',
    styleUrls: ['./weather-popup.component.css'],
    standalone: false
})
export class WeatherPopupComponent implements OnInit {
  futureWeatherInfo:any;
  constructor(
    public dashBoardService: DashBoardService,
    private notification: NotificationService,
    private modalService: NgbModal,
    public activeModal: NgbActiveModal
  ) {}
  ngOnInit(): void {
    if(this.dashBoardService.weatherFutureInfo){
      this.futureWeatherInfo=this.dashBoardService.weatherFutureInfo?.forecast?.forecastday;
    }
  }
  onClose() {
    this.activeModal.dismiss(false);
  }
}
